// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-slider-standard-item-buzry{display:block;line-height:0}.components-slider-standard-image-blnxa{transition:all .1s ease-in-out;height:100%;width:100%;border-radius:12px;bottom:0;left:0;overflow:hidden;right:0;top:0}.components-slider-standard-image-blnxa:hover{filter:brightness(.85)}.components-slider-standard-video-jgsdi{height:auto;width:100%;left:0;-o-object-fit:cover;object-fit:cover;position:absolute;top:50%;transform:translateY(-50%)}.components-slider-standard-videoWrapper-bihsb{border-radius:12px;overflow:hidden;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-slider-standard-item-buzry",
	"image": "components-slider-standard-image-blnxa",
	"video": "components-slider-standard-video-jgsdi",
	"videoWrapper": "components-slider-standard-videoWrapper-bihsb"
};
module.exports = ___CSS_LOADER_EXPORT___;
